import React, {PropTypes} from 'react';


class Footer extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return <div className='Footer'>
      <span className='defaultView'>Copyright &copy; 2017 Diamonds Direct USA. All rights reserved.</span>
      <span className='mobileView'>Copyright &copy; 2017 Diamonds Direct USA.</span>
    </div>
  }
}
export default Footer;


// WEBPACK FOOTER //
// ./src/components/views/footer/Footer.jsx